import { useStaticQuery, graphql } from 'gatsby'
import parseQueryItems from './parseQueryItems'

const useFeaturedArtwork = () =>
  parseQueryItems(
    useStaticQuery(graphql`
      query {
        allMarkdownRemark(
          filter: {
            frontmatter: {
              templateKey: { in: ["product"] }
              featured: { eq: true }
              category: { eq: "artwork" }
            }
          }
        ) {
          edges {
            node {
              excerpt
              fields {
                slug
              }
              frontmatter {
                ...ItemFrontmatterFieldsFragment
                ...SquareProductImageFragment
              }
            }
          }
        }
      }
    `),
  )

export default useFeaturedArtwork
